import methods from '@/services/methods'

export default {
  reportsList (payload) {
    return methods.sendGet('reports', payload, {noHyptoLoader: true})
  },
  reportsUrl (id) {
    return methods.sendGet(`reports/${id}`)
  }
}
